import React from "react";
import "@/App.css";
import "@/index.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";

import { AuthProvider } from "@/lib/auth";
import { SettingsProvider } from "@/lib/settings";
import { ThemeProvider, useTheme } from "@/lib/theme";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Directory from "@/pages/Directory";
import MemberProfile from "@/pages/MemberProfile";
import AdminLogin from "@/pages/AdminLogin";
import AdminLayout from "@/pages/admin/AdminLayout";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminAnalytics from "@/pages/admin/AdminAnalytics";
import AdminSeoHealth from "@/pages/admin/AdminSeoHealth";
import AdminMembers from "@/pages/admin/AdminMembers";
import AdminEmail from "@/pages/admin/AdminEmail";
import AdminImport from "@/pages/admin/AdminImport";
import AdminSettings from "@/pages/admin/AdminSettings";
import AdminCms from "@/pages/admin/AdminCms";
import { About, Contact, NotFound, Privacy, Verification } from "@/pages/StaticPages";
import HowToRegister from "@/pages/HowToRegister";
import Register from "@/pages/Register";
import Login from "@/pages/Login";
import MemberAccount from "@/pages/MemberAccount";
import ForgotPassword from "@/pages/ForgotPassword";
import ForceChangePassword from "@/pages/ForceChangePassword";
import AddFriend from "@/pages/AddFriend";
import InvoiceEditor from "@/pages/InvoiceEditor";
import LoginPromptModal from "@/components/LoginPromptModal";
import { AnalyticsRouteTracker } from "@/lib/analytics";

function PublicShell({ children }) {
  return <Layout>{children}</Layout>;
}

function AppToaster() {
  const { theme } = useTheme();
  return <Toaster richColors position="top-right" theme={theme} />;
}

function App() {
  return (
    <div className="App">
      <ThemeProvider>
        <AuthProvider>
          <SettingsProvider>
            <BrowserRouter>
              <Routes>
                <Route path="/" element={<PublicShell><Home /></PublicShell>} />
                <Route path="/gomore" element={<PublicShell><Directory /></PublicShell>} />
                <Route path="/directory" element={<PublicShell><Directory /></PublicShell>} />
                <Route path="/member/:memberId" element={<PublicShell><MemberProfile /></PublicShell>} />
                <Route path="/register" element={<PublicShell><Register /></PublicShell>} />
                <Route path="/add-friend" element={<PublicShell><AddFriend /></PublicShell>} />
                <Route path="/login" element={<PublicShell><Login /></PublicShell>} />
                <Route path="/forgot-password" element={<PublicShell><ForgotPassword /></PublicShell>} />
                <Route path="/account" element={<PublicShell><MemberAccount /></PublicShell>} />
                <Route path="/account/first-login" element={<PublicShell><ForceChangePassword /></PublicShell>} />
                <Route path="/account/invoices/new" element={<PublicShell><InvoiceEditor /></PublicShell>} />
                <Route path="/account/invoices/:invoiceId" element={<PublicShell><InvoiceEditor /></PublicShell>} />
                <Route path="/how-to-register" element={<PublicShell><HowToRegister /></PublicShell>} />
                <Route path="/about" element={<PublicShell><About /></PublicShell>} />
                <Route path="/privacy" element={<PublicShell><Privacy /></PublicShell>} />
                <Route path="/verification" element={<PublicShell><Verification /></PublicShell>} />
                <Route path="/contact" element={<PublicShell><Contact /></PublicShell>} />
                <Route path="/admin/login" element={<PublicShell><AdminLogin /></PublicShell>} />
                <Route path="/adminpronet2026" element={<PublicShell><AdminLogin /></PublicShell>} />
                <Route path="/admin" element={<AdminLayout />}>
                  <Route index element={<AdminDashboard />} />
                  <Route path="analytics" element={<AdminAnalytics />} />
                  <Route path="seo" element={<AdminSeoHealth />} />
                  <Route path="members" element={<AdminMembers />} />
                  <Route path="email" element={<AdminEmail />} />
                  <Route path="import" element={<AdminImport />} />
                  <Route path="settings" element={<AdminSettings />} />
                  <Route path="cms" element={<AdminCms />} />
                </Route>
                <Route path="*" element={<PublicShell><NotFound /></PublicShell>} />
              </Routes>
              <AnalyticsRouteTracker />
              <LoginPromptModal />
            </BrowserRouter>
            <AppToaster />
          </SettingsProvider>
        </AuthProvider>
      </ThemeProvider>
    </div>
  );
}

export default App;
